import React, { useState, useContext, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import { Footer, Header, DotsLoader } from "../../components";
import "./styles.css";
import { Images } from "../../theme";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";
import moment from "moment";
import Form from "./Form";

export default function WithDraw() {
  const getAmountContext = useContext(GlobalContext);
  let {
    isLoading,
    get_all_withdrawel,
    get_balance,
    userBalance,
    secondLoader,
    userWithdraw,
    post_withdrawel,
  } = getAmountContext;
  const { t } = useTranslation();
  let navigate = useNavigate();

  const [withdrawModal, setWithdrawModal] = useState(false);

  const onCloseWithdrawModal = () => setWithdrawModal(false);

  useEffect(() => {
    get_all_withdrawel();
    get_balance();
  }, []);

  function widthdrawel(data) {
    post_withdrawel(data, onCloseWithdrawModal);
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12 withdrawStyle">
            <span className="addressHeading">{t("Withdraw")}</span>
            {userWithdraw.length < 1 ? null : (
              <button
                class="btn-custom btn-light WithDrawSaveBtn"
                disabled={userBalance < 1 ? true : false}
                onClick={() => setWithdrawModal(true)}
              >
                {secondLoader ? (
                  <DotsLoader />
                ) : (
                  `${t("Withdraw")} $${userBalance}`
                )}
              </button>
            )}
          </div>

          <div>
            {isLoading ? (
              <DotsLoader />
            ) : userWithdraw.length ? (
              userWithdraw?.map((item, index) => {
                return (
                  <div className="row boxShadowDrawCard">
                    <div className="col-md-12">
                      <div>
                        <span className="headingWidthCard">
                          {item.bank_name}
                        </span>
                        <span className="feeheadingWidthCard">
                          (Withdrawal fee: {item.fees})
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3 mt-2">
                      <span className="dateheadingWidthCard">
                        Date of Request:{" "}
                        {moment(item.created_at).format("MM-DD-YYYY ")}
                        Requested (${item.amount})
                      </span>
                    </div>
                    <div className="col-md-4 mt-2">
                      <span className="reqheadingWidthCard">
                        To: {item.account_name} [{item.account_number}] Amount
                        (${item.total})
                      </span>
                    </div>
                    <div className="col-md-5 drawbtndivRight">
                      <button
                        className="drawbtnActiveRental"
                        style={{
                          backgroundColor:
                            item.status == "pending"
                              ? "#FFC000"
                              : item.status == "accepted"
                              ? "#0BD437"
                              : "#D40B0B",
                        }}
                      >
                        {item.status}
                      </button>
                      <br />
                      <p className="drawTextActiveRental">
                        Status Update on{" "}
                        {moment(item.updated_at).format("MM-DD-YYYY")}
                      </p>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-md-12 mt-5 text-center">
                <img src={Images.withDraw} alt="image" />
                <h4 className="withDrawHeading">{t("No_Withdrawal")}</h4>
                <p className="withDrawDes">{t("Any_withdrawals_available")}</p>
                <button
                  class="btn-custom btn-light withdrawBtn"
                  onClick={() =>
                    userBalance < 1
                      ? navigate("/Listanitem")
                      : setWithdrawModal(true)
                  }
                >
                  {secondLoader ? (
                    <DotsLoader />
                  ) : userBalance < 1 ? (
                    t("go_lend_something")
                  ) : (
                    `${t("Withdraw")} $${userBalance}`
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
      <Modal
        classNames={{
          modal: "categoryModal withdraw-modal",
        }}
        open={withdrawModal}
        onClose={onCloseWithdrawModal}
        center
      >
        <Form
          widthdrawel={widthdrawel}
          isLoading={isLoading}
          userBalance={userBalance}
        />
      </Modal>
    </>
  );
}
